import { render, staticRenderFns } from "./DriverInfo.vue?vue&type=template&id=53cf1a50&scoped=true&"
import script from "./DriverInfo.vue?vue&type=script&lang=js&"
export * from "./DriverInfo.vue?vue&type=script&lang=js&"
import style0 from "./DriverInfo.vue?vue&type=style&index=0&id=53cf1a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cf1a50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VChip,VImg})
